// 24.docx — every email must be classified with an exact reason.
export const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function emailInvalidReason(raw) {
  const e = (raw || "").trim();
  if (!e) return "Empty email";
  if (/\s/.test(e)) return "Contains spaces";
  const atCount = (e.match(/@/g) || []).length;
  if (atCount === 0) return "Missing @";
  if (atCount > 1) return "Invalid email format (multiple @)";
  const [local, domain] = e.split("@");
  if (!local) return "Missing name before @";
  if (!domain || !domain.includes(".") || domain.startsWith(".") || domain.endsWith(".") || domain.includes("..")) return "Missing/invalid domain";
  if (!EMAIL_RX.test(e)) return "Invalid email format";
  return null;
}

export function auditRecipientText(text) {
  const entries = (text || "").split(/[\n,;]+/).map((s) => s.trim()).filter(Boolean);
  const seen = new Map(); // lc -> occurrence count
  const invalid = [];
  for (const e of entries) {
    const reason = emailInvalidReason(e);
    if (reason) { invalid.push({ email: e, reason }); continue; }
    const lc = e.toLowerCase();
    seen.set(lc, (seen.get(lc) || 0) + 1);
  }
  const unique = [...seen.keys()];
  const duplicates = [...seen.entries()].filter(([, c]) => c > 1).map(([email, count]) => ({ email, count }));
  return {
    entries,
    total: entries.length,
    unique,
    duplicates,
    duplicateExtra: entries.length - invalid.length - unique.length,
    invalid,
    willSend: unique.length,
  };
}
